import { ArrowUpTrayIcon, DocumentTextIcon } from "@heroicons/react/24/solid";
import { FC, useState } from "react";
import { toast } from "react-toastify";
import { ReportEntry } from "../../../@types/ReportEntry";
import {} from "../../../service/api";
import { downloadFile } from "../../../service/reportEntry";
import { Tooltip } from "@mui/material";
import FilePreview from "../FilePreview";
import Modal from "../Modal";

interface ViewDocumentProps {
  reportEntry: ReportEntry;
  styleClass?: string;
  isMobile?: boolean;
}

export const ViewDocument: FC<ViewDocumentProps> = ({ reportEntry, styleClass, isMobile }) => {
  const [openDoc, setOpenDoc] = useState<boolean>(false);
  const [fileUrl, setFileUrl] = useState<string>("");
  const [fileType, setFileType] = useState<string>("");
  const [attachmentLoaded, setAttachmentLoaded] = useState(false);

  const handleDocumentClick = async () => {
    try {
      if (!attachmentLoaded) {
        const response = await downloadFile(reportEntry.id);
        const fileExtension = reportEntry.s3FileName.split(".").pop()?.toLowerCase() || "";
        const blob = new Blob([response], { 
          type: fileExtension === 'pdf' ? 'application/pdf' : 'application/octet-stream'
        });
        const imageUrl = URL.createObjectURL(blob);

        let mimeType = 'application/octet-stream';

        if (fileExtension === 'pdf') {
          mimeType = 'application/pdf';
        } else if (fileExtension === 'jpg' || fileExtension === 'jpeg') {
          mimeType = 'image/jpeg';
        } else if (fileExtension === 'png') {
          mimeType = 'image/png';
        }

        setFileUrl(imageUrl);
        setFileType(mimeType);
        setAttachmentLoaded(true);
      }
      setOpenDoc(true);
    } catch (error) {
      toast.error("Erro ao realizar upload de arquivo");
    }
  };

  return (
    <>
      <Tooltip title={"Visualizar comprovante"}>
        <DocumentTextIcon
          fill="#6B7280"
          className={`w-6 h-6 text-color-text hover:cursor-pointer ${styleClass}`}
          onClick={handleDocumentClick}
        />
      </Tooltip>
      <Modal
        title={"Comprovante"}
        widthPanel={isMobile ? "w-[80%]" : "w-[55%]"}
        isOpen={openDoc}
        setIsOpen={setOpenDoc}
        body={
          <div className="max-h-[80vh] overflow-y-auto">
            <div className="flex flex-col gap-3">
              <div>
                <p className="text-sm text-gray-500 mb-1">Anexo</p>
                <div className="flex justify-center">
                  <button className="flex bg-vcolor text-white items-center justify-center rounded-md drop-shadow-lg hover:bg-vcolor-hover px-3 py-1.5">
                    <a href={fileUrl} download={reportEntry.s3FileName} className="flex items-center space-x-2">
                      <span>Download</span>
                      <ArrowUpTrayIcon className="w-4 h-4" />
                    </a>
                  </button>
                </div>
              </div>

              <div>
                <FilePreview fileUrl={fileUrl} fileType={fileType} fileName={reportEntry.s3FileName} isMobile={isMobile} />
              </div>

              <div>
                <p className="text-sm text-gray-500 mb-1">Descrição</p>
                <textarea
                  className="w-full bg-gray-50 border border-gray-300 text-gray-800 text-sm rounded-md block p-1.5 dark:bg-white dark:border-gray-400 dark:placeholder-gray-400 dark:text-gray-600"
                  name="description"
                  rows={2}
                  value={reportEntry.description}
                  disabled
                ></textarea>
              </div>
            </div>
          </div>
        }
        bottom={<></>}
      />
    </>
  );
};
